import * as React from 'react'
import { GridColumns } from '@mui/x-data-grid'
import { Avatar, Box, Checkbox, Container, Typography } from '@mui/material'
import { deepOrange } from '@mui/material/colors'
import { getFirstLetter } from '../../../utils'
import { translate as t } from '../../../i18n'
import useResponsive from 'hooks/useResponsive'

export const Columns: GridColumns = [
  {
    field: 'athleteName',
    renderHeader: () => (t('routine.gridColumns.label')),
    flex: 2,
    valueGetter: (params) => params.row.athleteName,
    renderCell: (params) => {
      return <Box sx={{ display: 'flex', textAlign: 'left', flexDirection: 'row' }}>
        <Box padding-left="0px" sx={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
          {params.row.athleteImagePath
            ? <Avatar alt="" src={params.row.athleteImagePath} sx={{ width: 56, height: 56 }} />
            : <Avatar sx={{ bgcolor: 'rgb(250, 89, 62, 0.1)', width: 56, height: 56, fontWeight: 'bold', zIndex: 1 }}>
              <Typography component="h1" variant="h5" sx={{ color: deepOrange[500], zIndex: 9 }}>{getFirstLetter(params.row.athleteName)}</Typography>
            </Avatar>
          }
        </Box>
        <Box sx={{ justifyContent: 'center', display: 'flex', flexDirection: 'column', paddingLeft: 1, textAlign: 'left' }}>
          <span style={{ fontWeight: 'bold' }}>{params?.row?.athleteName} {params?.row?.athleteSurname}</span>
          <span> { useResponsive('up', 'md') && params?.row?.athleteEmail }</span>
        </Box>
      </Box>
    }
  },
  {
    field: 'name',
    renderHeader: () => (t('routine.gridColumns.routine')),
    flex: 2,
    valueGetter: (params) => params?.row?.name,
    editable: true
  },
  {
    field: 'note',
    renderHeader: () => (t('routine.gridColumns.note')),
    flex: 2,
    valueGetter: (params) => params?.row?.note,
    editable: true
  },
  {
    field: 'startedAt',
    renderHeader: () => (t('routine.gridColumns.startedAt')),
    flex: 0.7,
    valueGetter: (params) => params?.row?.startedAt,
    editable: true,
    type: 'date'
  },
  {
    field: 'dueDateAt',
    renderHeader: () => (t('routine.gridColumns.dueDateAt')),
    valueGetter: (params) => params?.row?.dueDateAt,
    editable: true,
    flex: 0.7,
    type: 'date'
  },
  {
    field: 'visibleAfterDueDate',
    renderHeader: () => (t('routine.gridColumns.visibleAfterDueDate')),
    renderCell: (params) => (<Checkbox onChange={event => { params.row.visibleAfterDueDate = (event.target.checked ? true : false) }}/>),
    type: 'boolean',
    flex: 1.2
  }
]
